"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    className: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '云服务'
    }
  }
};